import React from "react";

/**
 * Logo Cloud Section - Display partner/sponsor logos
 */
export default function LogoCloudSection({ 
    title = "Våra partners",
    description,
    logos = [],
    backgroundColor = "sage"
}) {
    const bgColorClass = backgroundColor === "sage" ? "bg-sage" : backgroundColor === "white" ? "bg-white" : "bg-offwhite";

    return (
        <section className={`py-16 sm:py-20 lg:py-24 ${bgColorClass}`}>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-lg text-center">
                    <h2 className="text-2xl font-bold text-charcoal sm:text-3xl font-heading">
                        {title}
                    </h2>

                    {description && (
                        <p className="mt-4 text-pretty text-charcoal font-body">
                            {description}
                        </p>
                    )}
                </div>

                <div className="mt-8 grid grid-cols-2 gap-px md:grid-cols-4">
                    {logos.map((logo, index) => (
                        <div 
                            key={index} 
                            className="grid place-content-center p-6 sm:p-8"
                        >
                            <img 
                                src={logo.img} 
                                alt={logo.title} 
                                loading="lazy"
                                className="w-full h-20 sm:h-24 md:h-28 object-contain"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
